'use client';

import React, { useMemo } from 'react';
import Markdown from 'react-markdown';
import { cn } from '../../../utils/cn';

interface FormattedSummaryProps {
  content: string;
  className?: string;
}

/**
 * FormattedSummary component handles markdown-like formatting in summary content
 */
export const FormattedSummary: React.FC<FormattedSummaryProps> = ({ content, className = '' }) => {
  const processedContent = useMemo(() => {
    return content.replace(/\\\*([^*]+)\\\*/g, '**$1**');
  }, [content]);

  const paragraphs = useMemo(() => {
    return processedContent.split('\n\n').filter((p) => p.trim());
  }, [processedContent]);

  return (
    <div className="space-y-6">
      {paragraphs.map((paragraph, index) => (
        <Markdown key={index} className={cn('whitespace-pre-wrap', className)}>
          {paragraph}
        </Markdown>
      ))}
    </div>
  );
};
